export enum ConfigTypes {
    SET_CONFIG = 'SET_CONFIG'
}
